import { createContext } from 'react'

// Absent outside the Admin page boundary: shared fetch consumers stay unchanged.
export const PageLoadContext = createContext(null)
